import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import Card from "../components/custom/Card"
import CollapseCard from "../components/custom/CollapseCard"
import Main from "../components/custom/Main"
import PageContainer from "../components/custom/PageContainer"
import { FormType, FormTypeList } from "../config/functions"
import { AccountHolderType, addAccountHolderAction, deleteAccountHolderAction, editAccountHolderAction, fetchAccountHolderAction } from "../redux/actions/accountHolder"
import { AuthUserType } from "../redux/actions/authUserActions"
import { DropDownType } from "../redux/actions/dropDownAction"
import { StoreState } from "../redux/reducers"
import { AppDispatch } from "../redux/store"

interface TableBody {
    sno: number,
    groupName: string | undefined,
    accountName: string | undefined,
    place: string | undefined,
    contactNumber1: number | undefined | string,
    onEdit: MouseEventHandler<HTMLButtonElement>
    onDelete: MouseEventHandler<HTMLButtonElement>
}

type HandleEdit = (value: AccountHolderType) => void
type HandleDelete = (value: AccountHolderType) => void

const AccountHolder = () => {
    const dispatch = useDispatch<AppDispatch>()
    const AccountList = useSelector<StoreState, AccountHolderType[]>(state => state.account)?.filter(account => account.groupName !== 'main')
    const AuthUser = useSelector<StoreState, AuthUserType | null>(state => state.authUser)
    const GroupList = useSelector<StoreState, DropDownType[]>(state => state.dropDown)

    const [showDeleteForm, setShowDeleteForm] = useState<boolean>(false)
    const [formType, setFormType] = useState<FormType>(FormTypeList.ADD)
    const [editData, setEditData] = useState<AccountHolderType | null>(null)
    const [deleteId, setDeleteId] = useState<number | null | undefined>(null)
    const [accountNumber, setAccountNumber] = useState<number>()

    useEffect(() => {
        dispatch(fetchAccountHolderAction())
    }, [])


    const [groupName, setGroupName] = useState<string>('')
    const [groupNameError, setGroupNameError] = useState<string>('')
    const [nameTag, setNameTag] = useState<string>('')
    const [nameTagError, setNameTagError] = useState<string>('')
    const [accountName, setAccountName] = useState<string>('')
    const [accountNameError, setAccountNameError] = useState<string>('')
    // const [accountNumber, setAccountNumber] = useState<string>('')
    // const [accountNumberError, setAccountNumberError] = useState<string>('')
    const [address1, setAddress1] = useState<string>('')
    const [address1Error, setAddress1Error] = useState<string>('')
    const [address2, setAddress2] = useState<string>('')
    const [address2Error, setAddress2Error] = useState<string>('')
    const [accountCategory, setAccountCategory] = useState<string>("NON-ACCOUNT")
    const [accountCategoryError, setAccountCategoryError] = useState<string>('')
    const [allowSms, setAllowSms] = useState<boolean>(false)
    const [allowSmsError, setAllowSmsError] = useState<string>('')
    const [area, setArea] = useState<string>('')
    const [areaError, setAreaError] = useState<string>('')
    const [place, setPlace] = useState<string>('')
    const [placeError, setPlaceError] = useState<string>('')
    const [supplierPlace, setSupplierPlace] = useState<string>('')
    const [supplierPlaceError, setSupplierPlaceError] = useState<string>('')
    const [district, setDistrict] = useState<string>('')
    const [districtError, setDistrictError] = useState<string>('')
    const [pincode, setPincode] = useState<string | undefined>('')
    const [pincodeError, setPincodeError] = useState<string>('')
    const [state, setState] = useState<string>('')
    const [stateError, setStateError] = useState<string>('')
    const [country, setCountry] = useState<string>('')
    const [countryError, setCountryError] = useState<string>('')
    const [route, setRoute] = useState<string>('')
    const [routeError, setRouteError] = useState<string>('')
    const [contactNumber1, setContactNumber1] = useState<string | undefined>('')
    const [contactNumber1Error, setContactNumber1Error] = useState<string>('')
    const [contactNumber2, setContactNumber2] = useState<string | undefined>('')
    const [contactNumber2Error, setContactNumber2Error] = useState<string>('')
    const [oldBalance, setOldBalance] = useState<string>('')
    const [oldBalanceError, setOldBalanceError] = useState<string>('')
    const [asOnDate, setAsOnDate] = useState<string>('')
    const [asOnDateError, setAsOnDateError] = useState<string>('')
    const [gstNumber, setGstNumber] = useState<string | undefined>('')
    const [gstNumberError, setGstNumberError] = useState<string>('')
    const [aadharNumber, setAadharNumber] = useState<string | undefined>('')
    const [aadharNumberError, setAadharNumberError] = useState<string>('')
    const [contactPerson, setContactPerson] = useState<string>('')
    const [contactPersonError, setContactPersonError] = useState<string>('')
    const [contactPersonNumber, setContactPersonNumber] = useState<string | undefined>('')
    const [contactPersonNumberError, setContactPersonNumberError] = useState<string>('')
    const [bankAccountNumber, setBankAccountNumber] = useState<string | undefined>('')
    const [bankAccountNumberError, setBankAccountNumberError] = useState<string>('')
    const [bankName, setBankName] = useState<string>('')
    const [bankNameError, setBankNameError] = useState<string>('')
    const [bankBranchName, setBankBranchName] = useState<string>('')
    const [bankBranchNameError, setBankBranchNameError] = useState<string>('')
    const [ifscCode, setIfscCode] = useState<string>('')
    const [ifscCodeError, setIfscCodeError] = useState<string>('')
    const [areaName, setAreaName] = useState<string>('')
    const [areaNameError, setAreaNameError] = useState<string>('')
    const [openModal, setOpenModal] = useState(false)
    const [placeName, setPlaceName] = useState<string>('')
    const [placeNameError, setPlaceNameError] = useState<string>('')
    const [placeModal, setPlaceModal] = useState(false)
    const [supplierPlaceName, setSupplierPlaceName] = useState<string>('')
    const [supplierPlaceNameError, setSupplierPlaceNameError] = useState<string>('')
    const [showSupplierPlaceModal, setShowSupplierPlaceModal] = useState(false)
    const [routeName, setRouteName] = useState<string>('')
    const [routeNameError, setRouteNameError] = useState<string>('')
    const [routeModal, setRouteModal] = useState(false)
    const [districtName, setDistrictName] = useState<string>('')
    const [districtNameError, setDistrictNameError] = useState<string>('')
    const [districtModal, setDistrictModal] = useState(false)
    const [stateName, setStateName] = useState<string>('')
    const [stateNameError, setStateNameError] = useState<string>('')
    const [stateModal, setStateModal] = useState(false)
    const [countryName, setCountryName] = useState<string>('')
    const [countryNameError, setCountryNameError] = useState<string>('')
    const [countryModal, setCountryModal] = useState(false)
    const searchRef = React.useRef<HTMLInputElement>(null)
    const [searchQuery, setSearchQuery] = useSearchParams()
    const searchTerm = searchQuery.get('search') || ''
    const mainContentRef = React.useRef<HTMLDivElement>(null)
    const [showTable, setShowTable] = useState<boolean>(false);


    const [division, setDivision] = useState('');
    const [contactPersonNo, setContactPersonNo] = useState('');
    const [tillDate, setTillDate] = useState('');
    const [bankAccountNo, setBankAccountNo] = useState('');
    const [branchName, setBranchName] = useState('');

    // Error states
    const [nameError, setNameError] = useState('');
    const [contactNo1Error, setContactNo1Error] = useState('');
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    // pdf functionality
    const downloadPDF = (groupName: String) => {
        // const logoUrl = clients[0]?.shopPhoto;

        const doc = new jsPDF("landscape");
        const marginX = 10;
        const boxWidth = doc.internal.pageSize.width - 2 * marginX;
        const boxHeight = 25;
        let startY = 15;

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");

        doc.rect(marginX, startY - 5, boxWidth, boxHeight);

        // if (logoUrl) {
        //     doc.addImage(logoUrl, "JPEG", marginX + 5, startY - 2, 25, 20);
        // }

        // const textX = marginX + 35;

        // doc.text(clients[0]?.shopFullName || "", textX, startY);
        // doc.setFont("helvetica", "normal");
        // doc.text(
        //     `${clients[0]?.address1 || ""}, ${clients[0]?.address2 || ""}, ${clients[0]?.district || ""
        //     } `,
        //     textX,
        //     startY + 5
        // );
        // doc.text(
        //     `${clients[0]?.state || ""} - ${clients[0]?.pincode || ""}, ${clients[0]?.contactNo1 || ""
        //     }`,
        //     textX,
        //     startY + 10
        // );
        // doc.text(`GSTIN: ${clients[0]?.gstNo || ""}`, textX, startY + 15);

        const currentDate = new Date().toLocaleDateString("en-GB");
        const pageWidth = doc.internal.pageSize.width;
        doc.text(`Date: ${currentDate}`, pageWidth - marginX - 40, startY + 15);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        const heading = "Account Holder List";
        const headingWidth = doc.getTextWidth(heading);

        doc.text(heading, marginX + boxWidth - headingWidth - 10, startY + 8);

        // const AccountHolderCount = AccountList.length || 0;

        let filteredData = [];
        if (groupName) {
            filteredData = AccountList.filter((item) => item.groupName?.toLowerCase() === groupName.toLowerCase())

        } else {
            const order = ["supplier", "customer", "representer"];
            order.forEach((groupType) => {
                const filteredItems = AccountList.filter(
                    (item) => item.groupName?.toLowerCase() === groupType
                );
                filteredData.push(...filteredItems);

            })
            const remainingItems = AccountList.filter(
                (item) => !order.includes(item.groupName?.toLowerCase() ?? "")
            );
            filteredData.push(...remainingItems);
        }
        // console.log("Filtered Data:", filteredData);

        const AccountHolderCount = filteredData.length || 0;


        doc.text(`Total Account Holders:${AccountHolderCount}`,
            pageWidth - marginX - 60, startY + boxHeight + 3);


        const tableStartY = startY + boxHeight + 10;

        if (!filteredData || filteredData.length === 0) {
            doc.text("No data available", marginX, tableStartY);
            doc.save("AccountHolder.pdf");
            return;
        };

        let tableBody = filteredData.map((item, index) => [
            (index + 1).toString(),
            item.groupName || "",
            item.accountName || "",
            item.place || "",
            item.contactNumber1 || "0",
        ]);

        autoTable(doc, {
            startY: 47,
            head: [
                ["SI.No", "Group Name", "Account Name", "Place", "Contact Number"],
            ],
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 8, textColor: 0, lineColor: 0, lineWidth: 0.1 },
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: 0,
                fontStyle: "bold",
                lineColor: 0,
                lineWidth: 0.1,
            },
            margin: { top: 25, left: 10, right: 10 },
            columnStyles: {
                0: { halign: "center" },
                1: { halign: "left" },
                2: { halign: "left" },
                3: { halign: "left" },
                4: { halign: "left" },
            },

        });

        const pageCount = doc.getNumberOfPages();
        console.log(pageCount);

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            let pageHeight = doc.internal.pageSize.height;
            let footerY = pageHeight - 15;

            doc.setFontSize(10);
            doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, footerY);
        }

        doc.save("AccountHolder.pdf");
    };

    const searchTermChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchQuery({ search: e.target.value })
    }
    const filterAccountHandler = (account: any, searchTerm: any) => {
        return searchTerm !== '' ? (new RegExp(`^${searchTerm}|${searchTerm}`, 'gi').test(account.accountName)
            // || new RegExp(`^${searchTerm}|${searchTerm}`, 'gi').test(account.place)
            || new RegExp(`^${searchTerm}|${searchTerm}`, 'gi').test(account.contactNumber1)) : true || []
    }

    React.useEffect(() => {
        if (searchTerm !== '') {
            searchRef.current?.focus()
        }
    }, [])

    const handleEdit: HandleEdit = (value) => {
        setFormType(FormTypeList.UPDATE)
        setEditData(value)
    }

    const handleDelete: HandleDelete = async (value) => {
        setDeleteId(value.accountNumber)
        setShowDeleteForm(true)
    }

    const handleDeleteFormClose = () => {
        setShowDeleteForm(false)
    }

    const handleModalClose = () => {
        setOpenModal(false)
        setPlaceModal(false)
        setShowSupplierPlaceModal(false)
        setRouteModal(false)
        setDistrictModal(false)
        setStateModal(false)
        setCountryModal(false)
    }

    const resetStates = () => {
        setGroupName('')
        setNameTag('')
        setAccountName('')
        setBankName('')
        setBankAccountNumber('')
        setBankBranchName('')
        setIfscCode('')
        setAddress1('')
        setAddress2('')
        setArea('')
        setPlace('')
        setSupplierPlace('')
        setDistrict('')
        setPincode('')
        setState('')
        setCountry('')
        setRoute('')
        setContactNumber1('')
        setContactNumber2('')
        setContactNumber2Error('')
        setOldBalance('')
        setAsOnDate('')
        setAsOnDateError('')
        setGstNumber('')
        setGstNumberError('')
        setAadharNumber('')
        setAadharNumberError('')
        setContactPerson('')
        setContactPersonNumber('')
        setAreaName('')
        setPlaceName('')
        setRouteName('')
        setDistrictName('')
        setStateName('')
        setCountryName('')
        setEditData(null)
        setAccountCategory("NON-ACCOUNT")
        setAccountCategoryError('')
        setAllowSms(false)
        setAllowSmsError('')
        setGroupNameError("")
        setNameTagError('')
        setAccountNameError('')
        setAddress1Error('')
        setAddress2Error('')
        setAreaError('')
        setPlaceError('')
        setSupplierPlaceError('')
        setDistrictError('')
        setPincodeError('')
        setStateError('')
        setCountryError('')
        setRouteError('')
        setContactNumber1Error('')
        setContactNumber2Error('')
        setOldBalanceError('')
        setAsOnDateError('')
        setGstNumberError('')
        setAadharNumberError('')
        setContactPersonError('')
        setContactPersonNumberError('')
        setBankAccountNumberError('')
        setBankNameError('')
        setBankBranchNameError('')
        setIfscCodeError('')
        setAreaNameError('')
        setSupplierPlaceNameError('')
    }

    const handleSave = () => {
        let error = false

        const addData: AccountHolderType = {
            // accountNumber: id,
            branchId: AuthUser?.branchId?.toString() || '',
            groupName: groupName,
            nameTag: nameTag,
            accountName: accountName,
            contactNumber1: parseInt(contactNumber1 !== undefined ? contactNumber1 : ''),
            contactNumber2: parseInt(contactNumber2 !== undefined ? contactNumber2 : ''),
            address1: address1,
            address2: address2,
            area: area,
            place: place,
            supplierPlace: supplierPlace,
            district: district,
            pincode: parseInt(pincode !== undefined ? pincode : ''),
            state: state,
            country: country,
            route: route,
            oldBalance: parseInt(oldBalance),
            asOnDate: asOnDate,
            gstNumber: gstNumber,
            aadharNumber: parseInt(aadharNumber !== undefined ? aadharNumber : ''),
            contactPerson: contactPerson,
            contactPersonNumber: parseInt(contactPersonNumber !== undefined ? contactPersonNumber : ''),
            bankAccountNumber: parseInt(bankAccountNumber !== undefined ? bankAccountNumber : ''),
            bankName: bankName,
            bankBranchName: bankBranchName,
            accountCategory: accountCategory,
            allowSms: allowSms,
            ifscCode: ifscCode,
            // branch: `${AuthUser?.branchId}`
        }

        const editdata: AccountHolderType = {
            accountNumber: accountNumber,
            branchId: AuthUser?.branchId?.toString() || '',
            groupName: groupName,
            nameTag: nameTag,
            accountName: accountName,
            contactNumber1: parseInt(contactNumber1 !== undefined ? contactNumber1 : ''),
            contactNumber2: parseInt(contactNumber2 !== undefined ? contactNumber2 : ''),
            address1: address1,
            address2: address2,
            area: area,
            place: place,
            supplierPlace: supplierPlace,
            district: district,
            pincode: parseInt(pincode !== undefined ? pincode : ''),
            state: state,
            country: country,
            route: route,
            oldBalance: parseInt(oldBalance),
            asOnDate: asOnDate,
            gstNumber: gstNumber,
            aadharNumber: parseInt(aadharNumber !== undefined ? aadharNumber : ''),
            contactPerson: contactPerson,
            contactPersonNumber: parseInt(contactPersonNumber !== undefined ? contactPersonNumber : ''),
            bankAccountNumber: parseInt(bankAccountNumber !== undefined ? bankAccountNumber : ''),
            bankName: bankName,
            bankBranchName: bankBranchName,
            accountCategory: accountCategory,
            allowSms: allowSms,
            ifscCode: ifscCode,
            branch: `${AuthUser?.branchId}`

        }

        // if (branchId?.toString() === '') {
        //     setBranchIdError('Branch name required')
        //     error = true
        // }

        if (groupName === '') {
            setGroupNameError('Group name required')
            error = true
        }

        if (accountCategory === "") {
            setAccountCategoryError('Account category required')
            error = true
        }

        if (nameTag === '') {
            setNameTagError('Name tag required')
            error = true
        }

        if (accountName === '') {
            setAccountNameError('Account name required')
            error = true
        }

        if (!contactNumber1?.toString().trim()) {
            setContactNumber1Error('Primary contact number required');
            error = true;
        } else if (![10, 12].includes(contactNumber1.toString().trim().length)) {
            setContactNumber1Error('Enter a valid 10 or 12-digit primary contact number');
            error = true;
        }

        if (contactNumber2 && contactNumber2.toString().trim().length > 0) {
            if (![10, 12].includes(contactNumber2.toString().trim().length)) {
                setContactNumber2Error('Enter a valid 10 or 12-digit secondary contact number');
                error = true;
            }
        }

        if (groupName.toLocaleLowerCase() === 'supplier') {
            if (supplierPlace === '') {
                setSupplierPlaceError('Supplier place required')
                error = true
            }
        }

        if (pincode && pincode.toString().trim().length > 0) {
            if ((pincode?.toString() || '').length > 6 || (pincode?.toString() || '').length < 6) {
                setPincodeError('Enter your 6 digits pincode')
                error = true
            }
        }

        if (gstNumber && gstNumber.toString().trim().length > 0) {
            if ((gstNumber || '').length > 15 || (gstNumber || '').length < 15) {
                setGstNumberError('Enter your valid GST number')
                error = true
            }
        }

        if (aadharNumber && aadharNumber.toString().trim().length > 0) {
            if ((aadharNumber?.toString() || '').length > 12 || (aadharNumber?.toString() || '').length < 12) {
                setAadharNumberError('Enter your valid 12 digits aadhar number')
                error = true
            }
        }

        if (contactPersonNumber && contactPersonNumber.toString().trim().length > 0) {
            if (![10, 12].includes(contactPersonNumber.toString().trim().length)) {
                setContactPersonNumberError('Enter a valid 10 or 12-digit contact number');
                error = true;
            }
        }

        if (oldBalance !== '' && parseFloat(oldBalance) > 0) {
            if (asOnDate === '') {
                setAsOnDateError('Till Date Required')
                error = true
            }
        }

        if (!error) {
            if (formType === FormTypeList.ADD) {
                dispatch(addAccountHolderAction(addData)).then(text => {
                    toast.success(text, { position: 'top-right' })
                    resetStates()
                }).catch(text => {
                    toast.error(text, { position: 'top-right' })
                })
            } else if (formType === FormTypeList.UPDATE && editData !== null) {
                dispatch(editAccountHolderAction(editdata, editData?.accountNumber)).then(text => {
                    toast.success(text, { position: 'top-right' })
                    resetStates()
                    setEditData(null)
                    setFormType(FormTypeList.ADD)
                }).catch(text => {
                    toast.error(text, { position: 'top-right' })
                })
            }
        }
    }

    useEffect(() => {
        if ((formType === FormTypeList.UPDATE) && editData !== null) {
            const dateObj = new Date(editData.asOnDate || '')

            const d = dateObj.getDate().toString().padStart(2, '0')
            const m = (dateObj.getMonth() + 1).toString().padStart(2, '0')
            const y = dateObj.getFullYear().toString()

            setAccountNumber(editData.accountNumber)
            // setBranchId(editData.branchId?.toString() || '')
            setGroupName(editData.groupName || '')
            setNameTag(editData.nameTag || '')
            setAccountName(editData.accountName || '')
            setAddress1(editData.address1 || '')
            setAddress2(editData.address2 || '')
            setArea(editData.area || '')
            setPlace(editData.place || '')
            setSupplierPlace(editData.supplierPlace || '')
            setDistrict(editData.district || '')
            setPincode(editData.pincode?.toString() !== "0" ? editData.pincode?.toString() : '')
            setState(editData.state || '')
            setCountry(editData.country || '')
            setRoute(editData.route || '')
            setContactNumber1(editData.contactNumber1?.toString() !== '0' ? editData.contactNumber1?.toString() : '')
            setContactNumber2(editData.contactNumber2?.toString() !== '0' ? editData.contactNumber2?.toString() : '')
            setOldBalance(editData.oldBalance?.toString() || '')
            setAsOnDate(y + '-' + m + '-' + d)
            setGstNumber(editData.gstNumber || '')
            setAadharNumber(editData.aadharNumber?.toString() !== '0' ? editData.aadharNumber?.toString() : '')
            setContactPerson(editData.contactPerson || '')
            setContactPersonNumber(editData.contactPersonNumber?.toString() !== '0' ? editData.contactPersonNumber?.toString() : '')
            setBankAccountNumber(editData.bankAccountNumber?.toString() !== '0' ? editData.bankAccountNumber?.toString() : '')
            setBankName(editData.bankName || '')
            setBankBranchName(editData.bankBranchName?.toString() || '')
            setIfscCode(editData.ifscCode || '')
            setAccountCategory(editData.accountCategory || 'NON-ACCOUNT')
            setAllowSms(editData.allowSms || false)
        } else {
            resetStates()
        }
    }, [formType, editData])

    const openDeleteConfirmation = () => {
        setShowDeleteConfirmation(true);
    };

    const closeDeleteConfirmation = () => {
        setShowDeleteConfirmation(false);
    };

    const deleteHandler = (id: number) => {
        setDeleteId(id);
        openDeleteConfirmation();
    };

    const onDelete = () => {

        if (deleteId) {
            dispatch(deleteAccountHolderAction(deleteId)).then(text => {
                toast.success(text, { position: 'top-right' })
                setShowDeleteForm(false)
                closeDeleteConfirmation()
                setDeleteId(null)
                resetStates()
            }).catch(text => {
                toast.error(text, { position: 'top-right' })
            })
        }
    }

    return (
        <>
            <Main>
                <PageContainer title="Account Holder">
                    <Card title={formType === FormTypeList.UPDATE ? "Edit" : "Add"}>
                        <div className="row">
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Group Name <span className="text-danger">*</span> : </label>
                                {/* <input
                                    className={`form-control ${groupNameError ? 'is-invalid' : ''}`}
                                    placeholder="Enter group name..."
                                    type="text"
                                    onChange={(e) => {
                                        setGroupName(e.target.value);
                                        setGroupNameError('');
                                    }}
                                    value={groupName}
                                /> */}
                                <select className="form-control form-select" value={groupName} onChange={(e) => {
                                    setGroupName(e.target.value)
                                    setGroupNameError('')
                                    setSupplierPlace('')
                                    setSupplierPlaceError('')
                                }}>
                                    <option value={0}>Select </option>
                                    {GroupList?.filter((gl) => gl.category === "Account Group Name"
                                    )?.map((course) => (
                                        <option key={course.title} value={course.title}>{course.title}</option>
                                    ))}
                                </select>
                                {groupNameError && <div className="text-danger">{groupNameError}</div>}
                            </div>
                            {groupName?.toLowerCase() === 'supplier' && <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Supplier Place <span className="text-danger">*</span> : </label>
                                <input
                                    className={`form-control ${supplierPlace ? 'is-invalid' : ''}`}
                                    placeholder="Enter Supplier Place..."
                                    type="text"
                                    onChange={(e) => {
                                        setSupplierPlace(e.target.value);
                                        setSupplierPlaceError('');
                                    }}
                                    value={supplierPlace}
                                />
                                {supplierPlaceError && <div className="text-danger">{supplierPlaceError}</div>}
                            </div>}

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Account Category <span className="text-danger">*</span> : </label>
                                <select
                                    className={`form-control ${accountCategoryError ? 'is-invalid' : ''}`}
                                    value={accountCategory}
                                    onChange={(e) => {
                                        setAccountCategory(e.target.value);
                                        setAccountCategoryError('');
                                    }}
                                >
                                    <option value="">Select...</option>
                                    <option value="NON-ACCOUNT">NON-ACCOUNT</option>
                                </select>
                                {accountCategoryError && <div className="text-danger">{accountCategoryError}</div>}
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Account Name <span className="text-danger">*</span> : </label>
                                <input
                                    className={`form-control ${accountNameError ? 'is-invalid' : ''}`}
                                    placeholder="Enter Account name..."
                                    type="text"
                                    onChange={(e) => {
                                        setAccountName(e.target.value);
                                        setAccountNameError('');
                                    }}
                                    value={accountName}
                                />
                                {accountNameError && <div className="text-danger">{accountNameError}</div>}
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Name Tag <span className="text-danger">*</span> :</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={(e) => setNameTag(e.target.value)}
                                    value={nameTag}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">GST Number :</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={(e) => {
                                        setGstNumber(e.target.value)
                                        setGstNumberError('')
                                    }}
                                    value={gstNumber}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Aadhar No :</label>
                                <input
                                    className="form-control"
                                    type="number"
                                    onChange={(e) => {
                                        setAadharNumber(e.target.value)
                                        setAadharNumberError('')
                                    }}
                                    value={aadharNumber}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Address 1 : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter address..."
                                    type="text"
                                    onChange={(e) => {
                                        setAddress1(e.target.value)
                                        setAddress1Error('')
                                    }}
                                    value={address1}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Address  2 : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter address..."
                                    type="text"
                                    onChange={(e) => {
                                        setAddress2(e.target.value)
                                        setAddress2Error('')
                                    }}
                                    value={address2}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Route : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Route..."
                                    type="text"
                                    onChange={(e) => {
                                        setRoute(e.target.value)
                                        setRouteError('')
                                    }}
                                    value={route}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Place : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter Place..."
                                    type="text"
                                    onChange={(e) => {
                                        setPlace(e.target.value)
                                        setPlaceError('')
                                    }}
                                    value={place}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Division : </label>
                                <select className="form-control form-select" value={division} onChange={(e) => { setDivision(e.target.value) }}>
                                    <option value={0}>Select Division</option>
                                    {GroupList?.filter((gl) => gl.category === "Division"
                                    )?.map((course) => (
                                        <option key={course.title} value={course.title}>{course.title}</option>
                                    ))}
                                </select>
                                {countryError && <div className="text-danger">{countryError}</div>}
                            </div>

                            {/* <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Division : </label>
                                <select
                                    className="form-select"
                                    value={division}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="">Select...</option>
                                </select>
                            </div> */}
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">District : </label>
                                <select className="form-control form-select" value={district} onChange={(e) => { setDistrict(e.target.value) }}>
                                    <option value={0}>Select District</option>
                                    {GroupList?.filter((gl) => gl.category === "District"
                                    )?.map((course) => (
                                        <option key={course.title} value={course.title}>{course.title}</option>
                                    ))}
                                </select>
                                {districtError && <div className="text-danger">{districtError}</div>}
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">State : </label>
                                <select className="form-control form-select" value={state} onChange={(e) => { setState(e.target.value) }}>
                                    <option value={0}>Select State</option>
                                    {GroupList?.filter((gl) => gl.category === "State"
                                    )?.map((course) => (
                                        <option key={course.title} value={course.title}>{course.title}</option>
                                    ))}
                                </select>
                                {stateError && <div className="text-danger">{stateError}</div>}
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Pincode : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter PIN..."
                                    type="number"
                                    onChange={(e) => {
                                        setPincode(e.target.value)
                                        setPincodeError('')
                                    }}
                                    value={pincode}
                                />
                            </div>
                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Country : </label>
                                <select className="form-control form-select" value={country} onChange={(e) => { setCountry(e.target.value); setCountryError('') }}>
                                    <option value={0}>Select Country</option>
                                    {GroupList?.filter((gl) => gl.category === "Country"
                                    )?.map((course) => (
                                        <option key={course.id} value={course.title}>{course.title}</option>
                                    ))}
                                </select>
                                {countryError && <div className="text-danger">{countryError}</div>}
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Contact No. 1 <span className="text-danger">*</span> : </label>
                                <input
                                    className={`form-control ${contactNumber1Error ? 'is-invalid' : ''}`}
                                    placeholder="Enter contact no. 1..."
                                    type="number"
                                    onChange={(e) => {
                                        setContactNumber1(e.target.value);
                                        setContactNumber1Error('');
                                    }}
                                    value={contactNumber1}
                                />
                                {contactNumber1Error && <div className="text-danger">{contactNumber1Error}</div>}
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Contact No. 2 : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter contact no. 2..."
                                    type="number"
                                    onChange={(e) => setContactNumber2(e.target.value)}
                                    value={contactNumber2}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Contact Person : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter contact person..."
                                    type="text"
                                    onChange={(e) => setContactPerson(e.target.value)}
                                    value={contactPerson}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Contact Person No : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter contact person no..."
                                    type="number"
                                    onChange={(e) => setContactPersonNo(e.target.value)}
                                    value={contactPersonNo}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Old Balance : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter old balance..."
                                    type="text"
                                    onChange={(e) => setOldBalance(e.target.value)}
                                    value={oldBalance}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Till Date : </label>
                                <input
                                    className="form-control"
                                    type="date"
                                    onChange={(e) => setTillDate(e.target.value)}
                                    value={tillDate}
                                />
                            </div>

                            <div className="col-12 mt-3">
                                <h6 className="fw-bold">Bank Details:</h6>
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Bank Account No : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter bank account no..."
                                    type="text"
                                    onChange={(e) => setBankAccountNo(e.target.value)}
                                    value={bankAccountNo}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Branch Name : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter branch name..."
                                    type="text"
                                    onChange={(e) => setBranchName(e.target.value)}
                                    value={branchName}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">Bank Name : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter bank name..."
                                    type="text"
                                    onChange={(e) => setBankName(e.target.value)}
                                    value={bankName}
                                />
                            </div>

                            <div className='col-sm-6 col-md-4 col-lg-3'>
                                <label className="mt-3 mb-3">IFSC Code : </label>
                                <input
                                    className="form-control"
                                    placeholder="Enter IFSC code..."
                                    type="text"
                                    onChange={(e) => setIfscCode(e.target.value)}
                                    value={ifscCode}
                                />
                            </div>
                        </div>
                        <div className="text-end m-2">
                            <button className="btn btn-lg btn-secondary me-2" onClick={resetStates}>Reset</button>
                            <button className="btn btn-lg btn-success" onClick={handleSave}> {formType === FormTypeList.ADD ? 'Save' : 'Update'}</button>
                            {/* <Button className="me-3" variant="secondary" onClick={resetStates}>
                                
                            </Button>
                            <Button variant="success" onClick={handleSave}>
                                {formType === FormTypeList.ADD ? 'Save' : 'Update'}
                            </Button> */}
                        </div>

                    </Card>

                    <CollapseCard title="Account Holder List">
                        <div className="container-fluid" style={{ width: "100%" }}>
                            <table className="table table-striped">
                                <thead style={{ backgroundColor: "#10296C", color: "#fff" }}>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Group Name</th>
                                        <th>Account Name</th>
                                        <th>Place</th>
                                        <th>Contact No</th>
                                        <th>Options</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {AccountList?.map((branch, index) => (
                                        <tr key={branch.accountNumber}>
                                            <td>{index + 1}</td>
                                            <td>{branch.groupName}</td>
                                            <td>{branch.accountName}</td>
                                            <td>{branch.place}</td>
                                            <td>{branch.contactNumber1}</td>

                                            <td>
                                                <button className="btn btn-sm btn-primary" style={{ marginRight: '10px', backgroundColor: '#10296C' }} onClick={() => handleEdit(branch)}>Edit</button>
                                                <button className="btn btn-sm btn-danger" onClick={() => deleteHandler(branch.accountNumber!)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CollapseCard>
                </PageContainer>
                <Modal show={showDeleteConfirmation} onHide={closeDeleteConfirmation} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this branch?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeDeleteConfirmation}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={onDelete}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </Main>
        </>
    )
}
export default AccountHolder